// @flow
import React from 'react';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {ASPECT_RATIO} from '../constants';

import './LoadingCard.less';

const LoadingCard = () => {
    return (
        <div className={'loading-card'}>
            <AspectRatioCard aspectRatio={ASPECT_RATIO}>
                <div className="loading-card__img" data-slot="figure" />
                <div className="loading-card__content" data-slot="content">
                    <div className={'loading-card__property-details'} />
                    <div className="loading-card__avg-price" />
                    <div className="loading-card__rating" />
                </div>
            </AspectRatioCard>
        </div>
    );
};

export default LoadingCard;
